import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../AuthContext';

const SIDE = 'https://images.unsplash.com/photo-1517976547714-720226b864c1?auto=format&fit=crop&w=1200&q=80';

export default function Verify() {
  const { applySession } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const email = params.get('email') || '';
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);
  const [resending, setResending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(''); setNotice(''); setBusy(true);
    try {
      // On success the backend returns the session { token, user } — store it the
      // same way login does, then drop the user into the app.
      const { token, user } = await api.verifyEmail(email, code.trim());
      applySession(token, user);
      nav('/inbox');
    } catch (e) {
      setErr(e.message || 'Verification failed');
    } finally {
      setBusy(false);
    }
  };

  const onResend = async () => {
    setErr(''); setNotice(''); setResending(true);
    try {
      await api.resendCode(email);
      setNotice('A new code is on its way. Check your inbox.');
    } catch (e) {
      setErr(e.message || 'Could not resend the code');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-split">
      <div className="auth-left">
        <div className="auth-card">
          <div className="auth-brand">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'inherit', textDecoration: 'none' }}>
              <img src="/cnerzy-logo.png" alt="cnerzy" className="brand-logo" />
              <span>Rivet</span>
            </Link>
          </div>
          <h1>Verify your email</h1>
          <p className="muted" style={{ marginTop: 12 }}>
            We sent a 6-digit code{email ? <> to <strong>{email}</strong></> : ''}. Enter it below to finish setting up your account.
          </p>
          <form onSubmit={onSubmit}>
            <label className="field">
              <span className="label">Verification code</span>
              <input
                className="input"
                autoFocus
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                placeholder="123456"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              />
            </label>
            {notice && <div className="banner review">{notice}</div>}
            {err && <div className="banner risk">{err}</div>}
            <button className="btn" disabled={busy || code.length < 6} style={{ width: '100%' }}>
              {busy ? 'Verifying…' : 'Verify'}
            </button>
          </form>
          <div className="auth-footer">
            Didn’t get it?{' '}
            <button
              type="button"
              onClick={onResend}
              disabled={resending}
              style={{ background: 'none', border: 'none', padding: 0, color: 'var(--accent)', cursor: 'pointer', font: 'inherit' }}
            >
              {resending ? 'Sending…' : 'Resend code'}
            </button>
            {' · '}
            <Link to="/login">Back to sign in</Link>
          </div>
        </div>
      </div>
      <div className="auth-right" style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.78), rgba(0,0,0,0.55)), url(${SIDE})` }}>
        <div className="auth-right-inner">
          <div className="kicker light">Built for aerospace procurement</div>
          <h2>One quick step to secure your account.</h2>
        </div>
      </div>
    </div>
  );
}
